<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">Agendar vistoria</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs2>
        <v-container fluid class="py-2">
          <v-layout row wrap>
            <v-flex xs12 v-if="$hasGranularPermission('vistoria', 'add')">
              <v-btn flat @click.stop="onSubmit" :disabled="isFormInvalid">
                <span class="subtitulo">Salvar</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <form v-on:submit.prevent="onSubmit">
      <v-layout row wrap class="pt-5">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid class="px-0">
              <v-layout wrap class="ma-0">
                <v-flex xs12 class="pa-0">
                  <v-menu
                    lazy
                    v-model="menuData"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-left="40"
                    max-width="290px"
                    :nudge-top="80"
                  >
                    <v-text-field
                      slot="activator"
                      prepend-icon="today"
                      v-model="form.fields.data_formatada"
                      label="Adicionar data"
                      v-validate="'required'"
                      name="data"
                      data-vv-as="data"
                      :error-messages="errors.has('data') ? errors.first('data') : []"
                      single-line
                      full-width
                      hide-details
                      readonly
                      class="label_fix"
                    >
                    </v-text-field>
                    <v-date-picker
                      v-model="form.fields.data"
                      locale="pt-br"
                      autosave
                      :allowed-dates="datasPermitidas"
                      :date-format="date => new Date(date).toLocaleDateString()"
                      :formatted-value.sync="form.fields.data_formatada"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 class="pa-0">
                  <v-divider></v-divider>
                  <v-dialog v-model="dialogRecorrencia" @input="menuData = false">
                    <v-text-field
                      slot="activator"
                      v-model="form.fields.recorrencia_formatada"
                      label="Selecionar recorrência"
                      single-line
                      full-width
                      hide-details
                      prepend-icon="loop"
                      readonly
                      class="label_fix"
                    >
                    </v-text-field>
                    <v-card>
                      <v-card-title>
                        <div class="title">Selecionar recorrência</div>
                      </v-card-title>
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-switch
                              color="secondary"
                              hide-details
                              :label="recorrenciaToString"
                              v-model="form.fields.recorrencia">
                            </v-switch>
                          </v-flex>
                          <div v-if="form.fields.recorrencia" style="width: 100%;" class="mt-4">
                            <v-flex xs12>
                              <v-select
                                auto
                                v-model="form.fields.recorrencia_cada"
                                label="Repetir a cada"
                                v-validate="{ rules: { required: form.fields.recorrencia, min_value: 1 } }"
                                name="recorrencia_cada"
                                data-vv-as="repetir a cada"
                                :error-messages="errors.has('recorrencia_cada') ? errors.first('recorrencia_cada') : []"
                                v-bind:items="form.recorrenciaCada"
                              >
                              </v-select>
                            </v-flex>
                            <v-flex xs12>
                              <v-select
                                auto
                                v-model="form.fields.recorrencia_periodo"
                                v-bind:items="form.recorrenciaPeriodos"
                                label="Período"
                                v-validate="{ rules: { required: form.fields.recorrencia } }"
                                data-vv-as="período"
                                name="recorrencia_periodo"
                                :error-messages="errors.has('recorrencia_periodo') ? errors.first('recorrencia_periodo') : []"
                              >
                              </v-select>
                            </v-flex>
                          </div>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="secondary--text" flat @click.native="dialogRecorrencia = false">Ok</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
                <v-flex xs12 class="pa-0">   
                  <v-divider></v-divider>             
                  <v-dialog v-model="dialogUsuarios" transition="dialog-bottom-transition" :overlay="false" @input="menuData = false">
                    <v-text-field
                      slot="activator"
                      v-model="form.fields.user_name"
                      label="Selecionar usuário"
                      v-validate="'required'"
                      name="usuario"
                      data-vv-as="usuário"
                      :error-messages="errors.has('usuario') ? errors.first('usuario') : []"
                      single-line
                      full-width
                      hide-details
                      prepend-icon="person"
                      readonly
                      class="label_fix"
                    >
                    </v-text-field>
                    <v-card>
                      <v-toolbar dark class="primary">
                        <v-toolbar-title>Usuário</v-toolbar-title>
                      </v-toolbar>
                      <v-list two-line>
                        <v-list-tile v-for="(item, index) in users" v-bind:key="item.id" @click.native="selectUser(item.id)">
                          <v-list-tile-avatar class="avatar_sem_borda">
                            <img v-bind:src="item.avatar" class="avatar_borda" />
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ item.cargo }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action v-if="item.id === form.fields.user_id">
                            <v-icon class="secondary--text">done</v-icon>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-dialog>
                </v-flex>
                <v-flex xs12 class="pa-0">
                  <v-divider></v-divider>
                  <v-text-field
                      v-model="form.fields.observacoes"
                      label="Observações"
                      single-line
                      full-width
                      hide-details
                      prepend-icon="assignment"
                    >
                  </v-text-field>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import HeadersDetalhesResumo from '../Imoveis/Headers/HeadersDetalhesResumo'

  export default {
    components: {
      HeadersDetalhesResumo
    },
    data () {
      return {
        imovelId: this.$route.params.id,
        dialogUsuarios: false,
        dialogRecorrencia: false,
        menuData: false,
        datasPermitidas: (date) => {
          const today = new Date()
          return date.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0)
        },
        form: {
          fields: {
            data: '',
            data_formatada: '',
            recorrencia: false,
            recorrencia_cada: 1,
            recorrencia_periodo: 'mensal',
            recorrencia_formatada: '',
            user_id: '',
            user_name: '',
            observacoes: ''
          },
          recorrenciaCada: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          recorrenciaPeriodos: [
            { value: 'semanal', text: 'Semanal' },
            { value: 'mensal', text: 'Mensal' },
            { value: 'anual', text: 'Anual' }
          ]
        }
      }
    },
    mounted () {
      this.$primeUserRestrictions().then(() => {
        if (this.isLimitadoTarefas) {
          this.$store.dispatch('utils/showSnackbar', {
            text: 'Usuários limitados por tarefas/vistorias não podem adicionar vistoria.'
          })
          this.$router.replace({ name: 'ImoveisDetalhesResumo', params: { id: this.imovelId } })
          return
        }

        this.$store.dispatch('users/loadAssignableUsers')
      })
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      isLimitadoTarefas () {
        return this.$hasUserRestrictionFlag('limitado_tarefas')
      },
      users () {
        return this.$store.getters['users/users']
      },
      recorrenciaToString () {
        if (this.form.fields.recorrencia) {
          return 'Repete'
        } else {
          return 'Não repete'
        }
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    watch: {
      'form.fields.user_id' (value) {
        this.form.fields.user_name = _.find(this.users, { id: value }).name
      },
      'form.fields.recorrencia' () {
        this.formatarRecorrencia()
      },
      'form.fields.recorrencia_cada' () {
        this.formatarRecorrencia()
      },
      'form.fields.recorrencia_periodo' () {
        this.formatarRecorrencia()
      }
    },
    methods: {
      selectUser (userId) {
        this.form.fields.user_id = userId
        this.dialogUsuarios = false
      },
      formatarRecorrencia () {
        if (this.form.fields.recorrencia) {
          let periodoFormatadoSingular = ''
          let periodoFormatadoPlural = ''
          let periodoFormatado = ''

          switch (this.form.fields.recorrencia_periodo) {
            case 'semanal':
              periodoFormatadoSingular = 'semana'
              periodoFormatadoPlural = 'semanas'
              break
            case 'mensal':
              periodoFormatadoSingular = 'mês'
              periodoFormatadoPlural = 'meses'
              break
            case 'anual':
              periodoFormatadoSingular = 'ano'
              periodoFormatadoPlural = 'anos'
              break
          }

          periodoFormatado = (this.form.fields.recorrencia_cada > 1) ? periodoFormatadoPlural : periodoFormatadoSingular
          let recorrenciaFormatada = `A cada ${this.form.fields.recorrencia_cada} ${periodoFormatado}`
          this.form.fields.recorrencia_formatada = recorrenciaFormatada
        } else {
          this.form.fields.recorrencia_formatada = ''
        }
      },
      onSubmit () {
        if (this.isLimitadoTarefas) {
          return
        }

        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            axios.post(`${apiURL}/vistoria/${this.imovelId}`, this.form.fields).then((response) => {
              this.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: this.imovelId } })
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>

<style scoped>
  .label_fix { max-width: 250px; }
</style>



// WEBPACK FOOTER //
// VistoriaAdicionar.vue?425ef977